import {
  RESYNC_PLC_SECURITIES,
  RESYNC_PLC_SECURITIES_SUCCESSFUL,
  RESYNC_PLC_SECURITIES_FAILED,
} from './actionTypes';

export const resyncPlcSecurities = (request) => {
  return {
    type: RESYNC_PLC_SECURITIES,
    payload: { request },
  };
};

export const resyncPlcSecuritiesSuccessful = (response) => {
  return {
    type: RESYNC_PLC_SECURITIES_SUCCESSFUL,
    payload: response,
  };
};

export const resyncPlcSecuritiesFailed = (message) => {
  return {
    type: RESYNC_PLC_SECURITIES_FAILED,
    payload: message,
  };
};
